import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'numero_absoluto' })

export class NumeroAbsolutoPipe implements PipeTransform {
    transform(num: number, args?: any): any {
        return Math.abs(num);
    }
}